import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getTimeDate'
})
export class GetTimeDatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(value) {
      switch(args) {
        case 'time':
          return `${parseInt(value.split("T")[1].split(":")[0]) > 12 ? this.addZero(parseInt(value.split("T")[1].split(":")[0]) - 12): value.split("T")[1].split(":")[0]}:${value.split("T")[1].split(":")[1]} ${parseInt(value.split("T")[1].split(":")[0]) > 11 ? 'PM' : 'AM'}`
          break;
        case 'date':
          return new Date(value.split("T")[0].split("-")[0],value.split("T")[0].split("-")[1],value.split("T")[0].split("-")[2],0,0,0)
          break;
      }
    }
    return null;
  }

  addZero(val: number) {
    return val < 10 ? `0${val}`: val
  }
}
